<p-autoComplete [(ngModel)]="selectedLocation" [suggestions]="dropdownItems" appendTo="body" optionLabel="name" placeholder="Select a Location"
  (completeMethod)="search($event)" [completeOnFocus]="true" (onSelect)="onLocationSelected($event)" (onClear)="onLocationCleared()" [disabled]="disabled" [dropdown]="true"
  [forceSelection]="true">
  <ng-template let-location pTemplate="item">
    {{location.name}}
  </ng-template>
</p-autoComplete>
